// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"173":"b08e4292","634":"e521e199","971":"7dc29a23"}[chunkId] + ".chunk.js";
};